module.exports = __webpack_public_path__ + "img/img_job.359262e4.png";